import { render, staticRenderFns } from "./LimitedPage.vue?vue&type=template&id=7c492198&scoped=true&"
import script from "./LimitedPage.vue?vue&type=script&lang=js&"
export * from "./LimitedPage.vue?vue&type=script&lang=js&"
import style0 from "./LimitedPage.vue?vue&type=style&index=0&id=7c492198&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c492198",
  null
  
)

export default component.exports